export const instructors = [
  {
    id: 2,
    name: '황지원',
    title: '발성 · 뮤지컬 전담 강사',
    belt: '강남입시학원 11년 지도 경력',
    experience: '입시뮤지컬 전문강사',
    quote: '목소리는 배우의 악기입니다. 올바른 발성과 호흡은 모든 연기의 기초가 됩니다. 여러분 각자의 목소리가 가진 아름다움을 발견하고 키워가는 과정을 함께하고 싶습니다.',
    specialties: ['발성·발음', '뮤지컬 연기', '노래 연기'],
    certifications: ['경기대학교 연기학과 졸업', '강남입시학원 11년 지도 경력', '보컬 코칭 전문 과정 수료'],
    image: 'https://storage.readdy-site.link/project_files/6ba0cd05-38f2-4780-9d35-22df294407b6/97823fe5-1b0e-454a-87e4-71b26103aaae_KakaoTalk_20260323_205959120.jpg?v=0f589626d09b63836cf787108e4eff9d',
    imageTransform: 'scale(1.2) translateY(10%)',
  },
  {
    id: 3,
    name: '정구현',
    title: '입시 전문 지도 강사',
    belt: '입시전문 지도 5년 · 현 TV 매체 배우 활동중',
    experience: '',
    quote: '입시는 결과만큼 과정이 중요합니다. 매 수업마다 학생이 한 걸음씩 성장하는 것을 지켜볼 때 가장 큰 보람을 느낍니다. 목표를 향해 함께 달려갈 준비가 되어 있습니다.',
    specialties: ['카메라 연기', '입시 실기', '영상 연기'],
    certifications: ['성결대학교 연극영화학과 졸업', 'TV 드라마 출연 경력', '입시 전문 지도 5년'],
    image: 'https://static.readdy.ai/image/0227718025500d4b5e94dda25ab00f4a/bafdfaddfc7c90663c3f91d1c52379fe.jpeg',
    imageTransform: 'scale(1.2) translateY(0%)',
  },
  {
    id: 4,
    name: '이서윤',
    title: '연기 · 뮤지컬 전담 강사',
    belt: '세종대학교 일반대학원 영화예술학과',
    experience: '배우 · 문화예술교육사 2급',
    quote: '무대 위에서 진심을 담아 살아 숨쉬는 것, 그것이 진정한 연기입니다. 뮤지컬부터 영화까지 다양한 현장 경험을 바탕으로 여러분의 가능성을 함께 키워가겠습니다.',
    specialties: ['뮤지컬 연기', '무대 연기', '영상 연기'],
    certifications: [
      '세종대학교 일반대학원 영화예술학과',
      '문화예술교육사 2급 보유',
    ],
    image: 'https://storage.readdy-site.link/project_files/6ba0cd05-38f2-4780-9d35-22df294407b6/e3ca66bb-09c0-4960-8e1b-75253eb3c979_KakaoTalk_20260323_215457085.jpg?v=ba4472cc9eac6c394946800c5b042b30',
    imageTransform: 'scale(1.2) translateY(-5%)',
  },
  {
    id: 5,
    name: '김보영',
    title: '현대무용 전담 강사',
    belt: '현대무용 지도 경력 10년',
    experience: '무용지도자 및 유아무용지도자',
    quote: '몸은 가장 솔직한 표현 도구입니다. 현대무용을 통해 자신만의 움직임 언어를 발견하고, 무대 위에서 자유롭게 이야기할 수 있도록 함께 만들어 가겠습니다.',
    specialties: ['현대무용', '신체 표현', '무대 퍼포먼스'],
    certifications: [
      '경희대학교 일반대학원 무용학과 수료',
      '현대무용 지도 경력 10년',
      '무용지도자 및 유아무용지도자',
    ],
    image: 'https://static.readdy.ai/image/0227718025500d4b5e94dda25ab00f4a/2df50230fcd6eeaee953a82bf2768cbb.jpeg',
    imageTransform: 'scale(1.5) translateY(-20%)',
  },
  {
    id: 6,
    name: '김후람',
    title: '취미 매체반 전담 강사',
    belt: '매체 연기 지도 4년',
    experience: '방송 영상 연기 활동',
    quote: '연기는 특별한 사람만의 것이 아닙니다. 누구든 카메라 앞에서 자신을 자연스럽게 표현할 수 있어요. 즐겁고 편안한 분위기 속에서 연기의 재미를 함께 느껴봐요.',
    specialties: ['카메라 연기', '취미 연기', '영상 연기'],
    certifications: [
      '연극영화학과 졸업',
      '방송 영상 연기 활동 경력',
      '취미 매체반 운영 4년',
    ],
    image: 'https://storage.readdy-site.link/project_files/6ba0cd05-38f2-4780-9d35-22df294407b6/988b4335-0246-4e37-8be0-d134aa7590f0_KakaoTalk_20260323_202321571.jpg?v=971404dcfb34bae2b63e0c98b2c99533',
    imageTransform: 'scale(1.2) translateY(-5%)',
  },
];
